import React from 'react';

type Props = {
  open: boolean;
  title?: string;
  body?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function ConfirmModal({ open, title, body, onConfirm, onCancel }: Props) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow max-w-lg w-full">
        <h3 className="text-lg font-semibold">{title ?? 'Confirmar'}</h3>
        <p className="mt-2 text-sm text-gray-700">{body ?? 'Tem certeza?'}</p>
        <div className="mt-4 flex justify-end gap-2">
          <button onClick={onCancel} className="px-4 py-2 rounded bg-gray-200">Cancelar</button>
          <button onClick={onConfirm} className="px-4 py-2 rounded bg-emerald-600 text-white">Confirmar</button>
        </div>
      </div>
    </div>
  );
}

